import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import Swal from 'sweetalert2';
import * as moment from 'moment';
import 'moment-timezone';
import { LoginService } from '../services/login.service';
import { DashboardService } from '../services/dashboard.service';

@Component({
  selector: 'app-emailreport',
  templateUrl: './emailreport.component.html',
  styleUrls: ['./emailreport.component.css']
})
export class EmailreportComponent implements OnInit {
    
  public session_data: any = {};
  public err: any = {};
  public tag_err: any = {};
  public result: any = {};
  public user_data: any = {};
  public project_id: any = {};
  public project = '';
  public keywords_form: any = {};
  public sources_form: any = {};
  public reports_form: any = {};
  public notification_form: any = {};
  public tags_form: any = {};
  public recipients = [];
  public notifications = [];
  public tags = [];
  public tag_with_names = [];
  public sentiment = 0;
  public country = '';
  public language = 'any';
  public countries: any = {};
  public checked_sm: any = {all: true, twitter: false, facebook: false, instagram: false, web: false, youtube: false, reviews: false, others: false};
  public show_notification_form: boolean = false;
  public show_tag_form: boolean = false;
  public notification_edit_form: boolean = false;
  public notification_edit_index: any = '';
  
  sentimant_filter_value = 0;
  sentimant_filter_options = {
    showTicksValues: true,
    hideLimitLabels: true,
    hidePointerLabels: true,
    stepsArray: [
      { value: -1, legend: "Negative" },
      { value: 0, legend: "All" },
      { value: 1, legend: "Positive" }
    ]
  };

  constructor(private router: Router, private service: DashboardService, private spinner: NgxSpinnerService, private login: LoginService, private route: ActivatedRoute, public fb: FormBuilder) {
    this.session_data.id = login.get_session_data('ieye_session_id');
    this.session_data.email = login.get_session_data('ieye_session_email');
    this.service.setTitle('Email Report | 24ieye');
    this.project_id = this.route.snapshot.queryParams["id"];
    this.keywords_form = this.fb.group({language: ['any']});
    this.notification_form = this.fb.group({email: [''], frequency: [''], filters: ['']});
    this.tags_form = {name: '', text: '', sentiment: '', categories: ''}
    this.sources_form = this.fb.group({web: [''], twitter: [''], facebook: [''], instagram: [''], youtube: [''], reviews: [''], others: ['']});
    this.reports_form = this.fb.group({reports: this.fb.array([this.fb.group({recipient: '', daily_report: true, weekly_report: true, daily_send_empty: 0, weekly_send_empty: 0})])});
    this.recipients = [];
    this.countries = this.get_countries();
  }

  ngOnInit(): void {
      this.get_project_data();
      this.get_settings_data();
      this.get_user_data();
  }
  
  public async get_user_data() {
    this.spinner.show();
    var formData: any = new FormData();
    formData.append("id", this.session_data.id);
    this.result = await this.service.form_actions(formData, 'get_data');
    this.spinner.hide();
    if (this.result == 'error') {

    }
    if (this.result.error == false) {

    } else {
      this.user_data = this.result.data; 
    }
  }
  
  public async get_countries() {   
        this.result = await this.service.get_actions({}, 'countries'); 
        this.countries = this.result;
  }
  
  public filter_by_country(event){ 
      this.country = event.target.value;
  }
  
  public language_filter(){
      var language = (<HTMLInputElement>document.getElementById('language_filter')).value; 
      this.language = language;
  }
  
  public senitment_filter_event(val){
      this.sentimant_filter_value = val;
  }
  
  public get_tag_name(id){
      return this.tag_with_names[id];
  }
  
  public sm_checkbox_event(e){
      if('all' == e.target.value){
          this.checked_sm.twitter = this.checked_sm.facebook = this.checked_sm.web = this.checked_sm.instagram = this.checked_sm.youtube = this.checked_sm.reviews = this.checked_sm.others = false;
      }
      if('twitter' == e.target.value)
        this.checked_sm.twitter = e.target.checked ? true : false;
      if('facebook' == e.target.value)
        this.checked_sm.facebook = e.target.checked ? true : false;
      if('web' == e.target.value)
        this.checked_sm.web = e.target.checked ? true : false;
      if('instagram' == e.target.value)
        this.checked_sm.instagram = e.target.checked ? true : false;
      if('youtube' == e.target.value)
        this.checked_sm.youtube = e.target.checked ? true : false;
      if('reviews' == e.target.value)
        this.checked_sm.reviews = e.target.checked ? true : false;
      if('others' == e.target.value)
        this.checked_sm.others = e.target.checked ? true : false;
        
      if(this.checked_sm.twitter || this.checked_sm.facebook || this.checked_sm.web || this.checked_sm.instagram || this.checked_sm.youtube || this.checked_sm.reviews || this.checked_sm.others){
        this.checked_sm.all = false;
      } else {
          this.checked_sm.all = true;
      }
  }
  
  public async save_tag(){
      var name = (<HTMLInputElement>document.getElementById('tag-name')).value;
      var text = (<HTMLInputElement>document.getElementById('tag-text')).value;
      var sentiment = this.sentimant_filter_value;
      var country = this.country;
      var language = this.language;
      var channels = this.checked_sm;
      
      var validation = true;
      this.tag_err = {}
      if(name == ''){
          this.tag_err.email = "Please enter the name.";
          validation = false;
      }
      if(validation){
            this.tags.forEach((values, index) => {
                if(values.name == name && values.text == text && values.sentiment == sentiment && values.country == country && values.language == language && values.channels == channels){
                    this.err.common = "This data is already exist.";
                    validation = false;
                    return false;
                }
            }); 
            if(validation){
                this.tags.push({id: moment().format('YYYYMMDDHHmmss'), name: name, text: text, sentiment: sentiment, country: country, language: language, channels: channels});
                this.show_tag_form = false;
                
                this.spinner.show();
                var formData: any = new FormData();
                formData.append("user_id", this.session_data.id);
                formData.append("project_id", this.route.snapshot.queryParams["id"]);
                formData.append("tags", JSON.stringify(this.tags));
                this.result = await this.service.form_actions(formData, 'add_tag'); 
                if (this.result.status == false) {
                    this.spinner.hide();
                        if (this.result.code == 202) {
                          this.err = {};
                          Swal.fire('Alert!', this.result.message, 'error');
                        } else {
                          this.err = this.result.errors;
                        }
                } else {
                    Swal.fire({ icon: 'success', title: this.result.message, showConfirmButton: false, timer: 1500 })
                    this.spinner.hide();
                }
            }         
      } 
  }
  
  public async add_more_notification(){
      this.notification_form = this.fb.group({email: [''], frequency: [''], filters: ['']});
      this.show_notification_form = true;
  }
  
  public tag_form(){
      this.tags_form = this.fb.group({name: [''], text: [''], sentiment: [''], categories: ['']});
      this.show_tag_form = true;
  }
  
  public async edit_notification_popup(notification, index){
      this.notification_form = this.fb.group({email: [notification.email], frequency: [notification.frequency], filters: [notification.filters]});
      this.show_notification_form = true; 
      this.notification_edit_form = true; 
      this.notification_edit_index = index;
  }
  
  public close_notification_form(){
      this.show_notification_form = false;
  }
  
  public close_tag_form(){
      this.show_tag_form = false;
  }
  
  public save_notification_in_array(form_data){ //console.log(form_data);
      var validation = true;
      this.err = {}
      if(form_data.email == ''){
          this.err.email = "Please select a email.";
          validation = false;
      }
      if(form_data.frequency == ''){
          this.err.frequency = "Please select a frequency.";
          validation = false;
      }
      if(validation){
          if(this.notification_edit_form){
              this.notifications.forEach((values, index) => {
                if(this.notification_edit_index != index){
                    if(values.email == form_data.email && values.frequency == form_data.frequency && values.filters == form_data.filters){
                        this.err.common = "This data is already exist.";
                        validation = false;
                        return false;
                    }
                }
            });
            if(validation){
                this.notifications[this.notification_edit_index ] = form_data;
                this.show_notification_form = false;
                this.notification_edit_form = false; 
                this.notification_edit_index = '';
            } 
          } else {
              this.notifications.forEach((values, index) => {
                if(values.email == form_data.email && values.frequency == form_data.frequency && values.filters == form_data.filters){
                    this.err.common = "This data is already exist.";
                    validation = false;
                    return false;
                }
            }); 
            if(validation){
                this.notifications.push(form_data);
                this.show_notification_form = false;
            }
          }
            
      }
        
  }
  
  public async notification_settings(){  
      this.spinner.show();
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);
        formData.append("notifications", JSON.stringify(this.notifications));
        this.result = await this.service.form_actions(formData, 'notification_settings'); 
        if (this.result.status == false) {
            this.spinner.hide();
                if (this.result.code == 202) {
                  this.err = {};
                  Swal.fire('Alert!', this.result.message, 'error');
                } else {
                  this.err = this.result.errors;
                }
        } else {
            Swal.fire({ icon: 'success', title: this.result.message, showConfirmButton: false, timer: 1500 })
            this.spinner.hide();
        }
  }
  
  public delete_notification(index){
	  Swal.fire({
		title: 'Are you sure?',
		text: "You won't be able to revert this!",
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		confirmButtonText: 'Yes, delete it!'
	  }).then((action) => {
		if (action.isConfirmed) {
			this.notifications.splice(index,1);
			//console.log(this.notifications);
		}
	  });
  }

  public async add_new_recipient(option){
      if(option.target.value == 'new'){
          var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            const { value: recipients } = await Swal.fire({
              title: 'Add New Reciepient',
              input: 'text',
                      customClass: {
                              container: 'compare_popup'
                              },
              inputPlaceholder: 'Email',
              showCancelButton: true,
              inputValidator: (value) => {
                return new Promise((resolve) => {
                  if (value === '') {
                    resolve('Please enter the email address.')
                  } else if(!value.match(mailformat)) {
                        resolve('Please enter the valid email address.')
                  } else if(this.recipients.indexOf(value) != -1){
                        resolve('Please enter the new email address.')
                  } else {
                      resolve();
                  }
                })
              }
          });

          if (recipients) {
              this.recipients.push(recipients);
          }  
      }
  }
  
  public async get_settings_data() {
    this.spinner.show();
    var formData: any = new FormData(); 
    formData.append("project_id", this.project_id);
    formData.append("user_id", this.session_data.id);
    this.result = await this.service.form_actions(formData, 'get_report_settings');
    this.spinner.hide();
    if (this.result == 'error') {
      Swal.fire('Alert!', 'Something went wrong! Please try again later.', 'error');
      return false;
    }
    if (this.result.error == false) {

    } else {
      this.keywords_form = this.fb.group({language: [this.result.data.language]});
      this.sources_form = this.fb.group(this.result.data.sources);
      this.recipients = this.result.data.recipients == '' ? [this.session_data.email] : this.result.data.recipients;
      this.notifications = this.result.data.notifications == '' ? [] : this.result.data.notifications;
      if(this.result.data.reports != ''){
          this.result.data.reports.forEach((values, index) => {
              this.reports.push(this.fb.group(values));
        });   
        this.deleteReport(0);       
      }
      this.tags = this.result.data.tags == '' ? [] : this.result.data.tags;
      this.tag_with_names = this.result.data.tag_with_names;
    }
  }
  
  get reports() {
    return this.reports_form.get('reports') as FormArray;
  }
  
  addReport() {
    this.reports.push(this.fb.group({recipient: '', daily_report: true, weekly_report: true, daily_send_empty: 0, weekly_send_empty: 0}));
  }
  
  deleteReport(index) {
    this.reports.removeAt(index);
  }
  
  public async get_project_data() {
    this.spinner.show();
    var formData: any = new FormData();
    formData.append("id", this.project_id);
    this.result = await this.service.form_actions(formData, 'get_project');
    this.spinner.hide();
    if (this.result == 'error') {
      Swal.fire('Alert!', 'Something went wrong! Please try again later.', 'error');
      return false;
    }
    if (this.result.error == false) {

    } else {
      this.project = this.result.data.name;
    }
  }
  
  public async report_settings(){   
      this.spinner.show();
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);
        formData.append("reports", JSON.stringify(this.reports_form.value.reports));
        formData.append("recipients", JSON.stringify(this.recipients));
        this.result = await this.service.form_actions(formData, 'report_settings'); 
        if (this.result.status == false) {
            this.spinner.hide();
                if (this.result.code == 202) {
                  this.err = {};
                  Swal.fire('Alert!', this.result.message, 'error');
                } else {
                  this.err = this.result.errors;
                }
        } else {
            Swal.fire({ icon: 'success', title: this.result.message, showConfirmButton: false, timer: 1500 })
            this.spinner.hide();
        }
  }

  public get_frequency_name(value){
      switch(value) { 
        case '60': { 
           return 'every hour';
           break; 
        } 
        case '360': { 
           return 'every 6 hours'; 
           break; 
        } 
        case '720': { 
           return 'every 12 hours'; 
           break; 
        } 
        case '1440': { 
           return 'once a day'; 
           break; 
        } 
        case '10080': { 
           return 'every week'; 
           break; 
        } 
        case '43200': { 
           return 'every month'; 
           break; 
        }  
        default: { 
           return '';
           break; 
        } 
     }  
  }

}
